import { Injectable, signal } from '@angular/core';
import { v4 as uuid } from 'uuid';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export interface Toast { id: string; type: ToastType; message: string; }

@Injectable({ providedIn: 'root' })
export class NotificationService {
  readonly toasts = signal<Toast[]>([]);

  private push(type: ToastType, message: string, duration = 3500) {
    const t: Toast = { id: uuid(), type, message };
    this.toasts.update(arr => [...arr, t]);
    setTimeout(() => this.dismiss(t.id), duration);
  }

  success(msg: string) { this.push('success', msg); }
  error(msg: string)   { this.push('error', msg); }
  info(msg: string)    { this.push('info', msg); }
  warning(msg: string) { this.push('warning', msg); }

  dismiss(id: string) { this.toasts.update(arr => arr.filter(t => t.id !== id)); }
}
